import styled from 'styled-components';

export const BannerLoaderContainer = styled.div(
  props => `
  display: flex;
  width: 100%;

  padding: ${props.theme.spacing.base};
  padding-top: 0;
  flex-direction: column;
  width: 60rem;
  z-index: ${props.theme.misc.zIndex.small};
`,
);

export const BannerImageLoader = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.custom(10)};
  height:19rem;
  width: 57rem;
  margin-bottom :${props.theme.spacing.large};

`,
);

export const BannerLoaderOuterWrap = styled.div(
  props => `

  display:flex;
  justify-content:space-between;

`,
);

export const BannerLoaderInnerWrap = styled.div(
  props => `

  display:flex;
  margin-right: ${props.theme.spacing.xlarge};
  flex-direction: column;

`,
);

export const OfferImageLoader = styled.div(
  props => `
  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width: 27.5rem;
  height: 10.8rem;
  margin-bottom :${props.theme.spacing.base};
`,
);

export const OfferDetailsLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:24.5rem;
  height:3.8rem;
  margin-bottom :${props.theme.spacing.base};
  margin-left:auto;
  margin-right:auto;

`,
);

export const OfferValidLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:24.5rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.base};
  margin-left:auto;
  margin-right:auto;

`,
);

export const SliderPriceLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:10rem;
  height:7rem;
  margin-bottom :${props.theme.spacing.small};

`,
);

export const SliderOfferLoader = styled.div(
  props => `

  display:flex;
  flex-wrap: wrap;
  flex-direction: row;
  background-color:${props.theme.colors.goBrandBlue.medium};
  border-radius:${props.theme.misc.borderRadius.small};
  width:7rem;
  height:1.5rem;
  margin-bottom :${props.theme.spacing.small};

`,
);
